module.exports = __webpack_public_path__ + "static/media/34.973611f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/34.png
// module id = 251
// module chunks = 0